<ion-list class="background-spacer">
  <ion-list-header>Users</ion-list-header>
  <ion-item button (click)="menuChoice('user-add')">
    <ion-text color="success">Add/Renew User</ion-text>
    <ion-icon color="success" slot="start" name="person-add-outline"></ion-icon>
  </ion-item>
  <ion-item button (click)="menuChoice('user-remove')" [disabled]="!userSelected">
    <ion-text color="danger">Remove User</ion-text>
    <ion-icon color="danger" slot="start" name="person-remove-outline"></ion-icon>
  </ion-item>
</ion-list>
